import {
  ClockCircleOutlined,
  LoadingOutlined,
  PlayCircleFilled,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { TagSelect } from "../../../../../src/shared/components/filters/tagSelect";
import { Button, Input, InputNumber, Row, Switch, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../context/globalContext";
import { transitionAnimationsDropDown } from "../../../../data/transitions";
import { aiTextToSoundEffect } from "@src/shared/utils/VideoGeneration/audioGeneration";
import { generateUniqueId } from "@src/shared/utils/core";
import { backgroundCover } from "@assets";
import { SectionTab } from "polotno/side-panel";
import { Clock02Icon } from "@src/features/polotno/component/hugeIcons/hugeIcons";
import './transitionRow.less';
// import {Tooltip } from '@blueprintjs/core'

// import './transitionRow.tsx'
interface TransitionRowProps {
  pageID: string;
  store: any;
}

type SoundEffect = {
  // Define the structure of your sound effect here
  id: string;
  musicName: string;
  url: string;
  // other properties...
};

export const TransitionRow = ({ store, pageID }: TransitionRowProps) => {
  const {
    TransitionAnimation: [, setTransitionAnimation],
    ScriptDetails: [scriptDetails, setScriptDetails],
    ActiveSidePanel: [activeSidePanel, setActiveSidePanel],
  } = useGlobalContext();

  useEffect(() => {
    setActiveSidePanel(store.openedSidePanel);
  }, []);

  const [transitionDuration, setTransitionDuration] = useState<number>(30);
  const [transitionValue, setTransitionValue] = useState<string>("fade");
  const [customSoundText, setCustomSoundText] = useState("");
  const [soundEffectLoading, setSoundEffectLoading] = useState(false);
  const [generatedSounds, setGeneratedSounds] = useState<SoundEffect[]>([]);

  useEffect(() => {
    if(scriptDetails.data[0]?.transition){
      setTransitionValue(scriptDetails.data[0].transition.animation);
      setTransitionDuration(scriptDetails.data[0].transition.duration);
    }
  }, [scriptDetails.data]);
  const handleTransitionValueChange = (selectedValue: string) => {
    const url = transitionAnimationsDropDown.find((item: any) => item.value === selectedValue)?.url;
    setTransitionValue(selectedValue);
    setTransitionAnimation([
      { animation: selectedValue, duration: transitionDuration },
    ]);

    setScriptDetails((prevScript: { data: any[] }) => {
      const updatedScript = {
        ...prevScript,
        data: prevScript.data.map((item) => ({
          ...item,
          sceneTransition: selectedValue,
          SceneTransitionAnimation: [
            { animation: selectedValue, duration: 30, url:url }, // Transition Duration is fixed to 30 seconds
          ],
        })),
      };

      return updatedScript;
    });
  };

  const handleTransitionDurationChange = (value: number | null) => {
    if (typeof value === "number" && value >= 1) {
      setTransitionDuration(value);
      setTransitionAnimation([{ animation: transitionValue, duration: value }]);
    }
  };

  const handleTransitionSound = (e: any) => {
    // setScriptDetails((prevScript: { data: any }) => {
    //   const updatedScript = { ...prevScript };

    //   return { ...updatedScript, transitionSound: e };
    // });

    setScriptDetails((prevScript: { data: any[]; transitionSound: any }) => {
      const updatedScript = {
        ...prevScript,
        transitionSound: e, // Update root-level transitionSound based on the event
        data: prevScript.data.map((item) => ({
          ...item,
          transitionSound: e, // Update transitionSound within each data item
        })),
      };

      return updatedScript;
    });
  };

  const handleOverlayAnimation = (e: any) => {
    setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };
      return { ...updatedScript, overlayAnimation: e };
    });
  };
  const handleInitialZoom = (e: any) => {
    setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };
      return { ...updatedScript, initialZoom: e };
    });
  };
  const handleCustomTransitionSwitch = (e: any) => {
    setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };

      return { ...updatedScript, customtransitionSound: e };
    });
  };
  const handleCutsomSoundText = async (e: any) => {
    setSoundEffectLoading(true);
    
    try {
      const soundeffectResponse = await aiTextToSoundEffect(customSoundText, 1);
   
      setGeneratedSounds((prev) => [
        ...prev,
        {
          id: generateUniqueId(),
          musicName: customSoundText,
          url: soundeffectResponse,
        },
      ]);
      const generatedTransitionSoundss =
        scriptDetails?.generatedTransitionSounds || [];
      setScriptDetails((prevScript: { data: any }) => {
        const updatedScript = { ...prevScript };

        return {
          ...updatedScript,
          generatedTransitionSounds: [
            ...generatedTransitionSoundss,
            {
              id: generateUniqueId(),
              musicName: customSoundText,
              url: soundeffectResponse,
            },
          ],
        };
      });
    } catch (error) {
      console.error(error);
    } finally {
      setSoundEffectLoading(false);
    }
  };

  const playSound = (url: string) => {
    const audioPlayer = new Audio(url);
    audioPlayer
      .play()
      .then(() => {
        // Audio playback started
      })
      .catch((e) => {
        console.error("Error playing audio:", e);
      });
  };

  const handleUse = (url: string) => {
    setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };
      return { ...updatedScript, customTransitionSoundurl: url };
    });
  };
  return (
    <div className="transition-row">
      <Tooltip title="Selecting this transition effect will automatically apply it to all scenes between the start and end, ensuring a consistent flow throughout.">
        <h3 className="section-title">
          <ClockCircleOutlined />
          Transition Effect
        </h3>
      </Tooltip>

      <div className="transition-select">
        <TagSelect
          dropdownItems={transitionAnimationsDropDown}
          placeholder="Wipe"
          defaultValue={transitionValue}
          onChange={handleTransitionValueChange}
        />
      </div>

      <h3 className="section-subtitle">Duration (ms)</h3>
      <div className="duration-input">
        <InputNumber
          size="small"
          placeholder="Duration"
          min={5}
          step={5}
          value={transitionDuration}
          onChange={handleTransitionDurationChange}
        />
      </div>

      <div className="switch-section">
        <span className="switch-label">Transition Sound</span>
        <Switch
          defaultChecked={scriptDetails?.transitionSound || false}
          value={scriptDetails?.transitionSound}
          onChange={handleTransitionSound}
        />
      </div>

      <div className="switch-section">
        <Tooltip title="Enabling custom sound effects allows the use of the generated sound.">
          <span className="switch-label">Custom Sound Effect</span>
        </Tooltip>
        <Switch
          defaultChecked={scriptDetails?.customtransitionSound || false}
          value={scriptDetails?.customtransitionSound || false}
          onChange={handleCustomTransitionSwitch}
        />
      </div>

      <div className={`custom-sound-section ${!scriptDetails?.customtransitionSound ? 'disabled' : ''}`}>
        <div className="input-row">
          <Input
            value={customSoundText}
            placeholder="Ex: Bhoom, lion roar"
            onChange={(e: any) => setCustomSoundText(e.target.value)}
          />
          <Button
            className="generate-button"
            onClick={handleCutsomSoundText}
            loading={soundEffectLoading}
            disabled={soundEffectLoading}
          >
            Generate
          </Button>
        </div>

        <h3 className="section-title">Generated Sounds</h3>
        <div className="generated-sounds">
          {scriptDetails?.generatedTransitionSounds?.map((sound: any) => (
            <div key={sound.id} className="sound-item">
              <div className="sound-info">
                <span>{sound.musicName}</span>
                <PlayCircleFilled
                  className="play-icon"
                  onClick={() => playSound(sound.url)}
                />
              </div>
              <Button
                className="use-button"
                onClick={() => handleUse(sound.url)}
                disabled={sound.url === scriptDetails?.customTransitionSoundurl}
              >
                {sound.url === scriptDetails?.customTransitionSoundurl ? "In Use" : "Use"}
              </Button>
            </div>
          ))}
        </div>
      </div>

      <div className="switch-section">
        <span className="switch-label">Overlay Animation</span>
        <Switch
          defaultChecked={scriptDetails?.overlayAnimation || false}
          value={scriptDetails?.overlayAnimation}
          onChange={handleOverlayAnimation}
        />
      </div>
      <div className="switch-section">
        <span className="switch-label">Initial Zoom</span>
        <Switch
          defaultChecked={scriptDetails?.initialZoom || false}
          value={scriptDetails?.initialZoom}
          onChange={handleInitialZoom}
        />
      </div>
    </div>
  );
};

export const CustomTransitionPolotno = {
  name: "transition-panel",
  Tab: (props: any) => (
    <SectionTab name="Transition" {...props}>
      <Clock02Icon className="sidebar-panel-tab-icon" />
    </SectionTab>
  ),
  Panel: TransitionRow,
};
